/**
 * Centralized accent color system for Default/Light and Dark modes.
 * Default/Light: AllEnquiries button color (#5e72e4).
 * Dark: Neon green (notification-style).
 */

export const themeColors = {
  default: {
    accent: "#5e72e4",
    accentHover: "#4c5fd6",
    accentActive: "#3d4eb8",
    accentMuted: "rgba(94, 114, 228, 0.12)",
    accentMutedHover: "rgba(94, 114, 228, 0.18)",
  },
  light: {
    accent: "#5e72e4",
    accentHover: "#4c5fd6",
    accentActive: "#3d4eb8",
    accentMuted: "rgba(94, 114, 228, 0.12)",
    accentMutedHover: "rgba(94, 114, 228, 0.18)",
  },
  dark: {
    accent: "#39FF14",
    accentHover: "#5dff3d",
    accentActive: "#2ed410",
    accentMuted: "rgba(57, 255, 20, 0.15)",
    accentMutedHover: "rgba(57, 255, 20, 0.25)",
  },
};

/**
 * Get accent colors for the current theme mode.
 * @param {"default" | "light" | "dark"} mode
 * @returns {typeof themeColors.default}
 */
export function getThemeColors(mode) {
  if (mode === "dark") return themeColors.dark;
  return themeColors.default;
}

/**
 * Create MUI theme palette.primary from accent for use with ThemeProvider.
 * Use with: createTheme({ palette: getMuiPalette(mode) })
 */
export function getMuiPalette(mode) {
  const c = getThemeColors(mode);
  return {
    primary: {
      main: c.accent,
      light: c.accentHover,
      dark: c.accentActive,
    },
    background: {
      default: mode === "dark" ? "#0d0d0d" : "#f8f9fe",
      paper: mode === "dark" ? "#262626" : "#ffffff",
    },
  };
}

/**
 * Create full MUI theme with accent-based primary (for pages that use createTheme).
 */
export function createMuiThemeFromMode(mode, baseTheme = {}) {
  const palette = getMuiPalette(mode);
  return {
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...palette,
      primary: {
        ...baseTheme.palette?.primary,
        ...palette.primary,
      },
      background: {
        ...baseTheme.palette?.background,
        ...palette.background,
      },
    },
  };
}
